// Address lookups are GET-only and carry what the customer typed (and the
// Mapbox token) in the URL, so observability SDKs must not record them.
export const ADDRESS_API_URLS = [
  /^https:\/\/api\.mapbox\.com\//,
  /^https:\/\/api-adresse\.data\.gouv\.fr\//,
];
